export const FILE_NAME = [
  'Work Centre Outputs',
  'SupplyVue Plan',
  'DRP Outputs',
  'DRP Outputs (Pivot)',
  'Constrained DRP',
  'Capacity Data',
].map((value) => ({ key: value, value }))
// Offered beside DRP Outputs on plans with a PlanningBookLedger (R3 answers 200).
export const PLANNING_BOOK_LEDGER = 'Planning Book Ledger'
export const FILE_NAME_WITH_LEDGER = FILE_NAME.flatMap((item) =>
  item.value === 'DRP Outputs (Pivot)'
    ? [item, { key: PLANNING_BOOK_LEDGER, value: PLANNING_BOOK_LEDGER }]
    : [item]
)
export const FILE_FORMATS = ['csv', 'xlxs'].map((value) => ({
  key: value,
  value,
}))

export const FILE_VERSION = ['Constrained', 'Unconstrained']
export const INITIAL_FILE_VERSION = ['Constrained']
export const INITIAL_FILE_FORMAT = 'csv'

export const SET_FILE_NAME = 'SET_FILE_NAME'
export const SET_FILE_VERSION = 'SET_FILE_VERSION'
export const SET_KEY_FIGURES = 'SET_KEY_FIGURES'
export const SET_FILE_FORMAT = 'SET_FILE_FORMAT'
